import { graphql, fetchQuery } from 'relay-runtime';
import type { Environment } from 'react-relay';
import type { userHasRovoDevAgentsAccessQuery } from '@atlassian/jira-relay/src/__generated__/userHasRovoDevAgentsAccessQuery.graphql';

export const userHasRovoDevAgentsAccess = async ({
	atlassianAccountId,
	cloudId,
	relayEnv,
}: {
	atlassianAccountId: string;
	cloudId: string;
	relayEnv: Environment;
}): Promise<boolean> => {
	const response = await fetchQuery<userHasRovoDevAgentsAccessQuery>(
		relayEnv,
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			query userHasRovoDevAgentsAccessQuery($atlassianAccountId: ID!, $cloudId: ID!) {
				devai_rovoDevAgentsUser(atlassianAccountId: $atlassianAccountId, cloudId: $cloudId)
					@required(action: THROW)
					@optIn(to: "DevAiUsers") {
					hasProductAccess
				}
			}
		`,
		{
			atlassianAccountId,
			cloudId,
		},
		{
			fetchPolicy: 'store-or-network',
		},
	).toPromise();
	return response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false;
};
